import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import type { FloormapConfig } from 'features/editor'

export const useSaveFloorMapMutation = () => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const queryClient = useQueryClient()

	const { mutate: saveFloorMap, isPending: isSaveFloorMapLoading } = useMutation({
		mutationFn: (floormapConfig: FloormapConfig) =>
			axiosPrivate.patch(apiRoutes.widget, { floormap_config: floormapConfig }),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.mapConfig.all })
			useToast({ type: 'success', message: t('Floor map updated') })()
		},
		onError: () => {
			useToast({ type: 'error', message: t('Something went wrong') })()
		}
	})

	return {
		saveFloorMap,
		isSaveFloorMapLoading
	}
}
